import { render, staticRenderFns } from "./page-level.vue?vue&type=template&id=08688d8d"
import script from "./page-level.vue?vue&type=script&lang=ts"
export * from "./page-level.vue?vue&type=script&lang=ts"
import style0 from "./page-level.vue?vue&type=style&index=0&id=08688d8d&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports